import { render, staticRenderFns } from "./MyWalletOrbitTableContent.vue?vue&type=template&id=0fcc7250&scoped=true"
import script from "./MyWalletOrbitTableContent.vue?vue&type=script&lang=ts"
export * from "./MyWalletOrbitTableContent.vue?vue&type=script&lang=ts"
import style0 from "./MyWalletOrbitTableContent.vue?vue&type=style&index=0&id=0fcc7250&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fcc7250",
  null
  
)

export default component.exports